<schedule-detail-header [title]="'Final Review'"
                        [subtitle]="subtitle()"
                        [backCallback]="goBack.bind(this)"
                        [showCloud]="true"
                        [isRefreshingInBackground]="isRefreshingInBackground()" />

<div class="extended-header"
     data-testid="final-review-extended-header">
  @if (step()==1) {
    <div class="needs-attention-header-subtext"
         data-testid="final-review-text-step1-header">
      Review your 'Needs Attention' items.
    </div>
  }
  @else {
    <div class="looks-good-header-subtext"
         data-testid="final-review-text-step2-header">
      {{ "Review your 'Looks Good' \n items that include images or notes." }}
    </div>
  }
</div>
<div class="final-review-container"
     [appDataUpdatedFade]="dataUpdatedPulse()"
     data-testid="final-review-container">

  @if (dataLoaded) {
    <!-- PAGE 1 – NEEDS ATTENTION -->
    @if (step() === 1) {
      @if (hasIssues()) {
        <div class="chart-section"
             data-testid="final-review-chart-section">
          <div class="chart-title">Total Issues</div>
          <div class="issues-chart-wrapper">
            @if (isCcmInspection()) {
              <app-issues-chart [minor]="minorIssues().length"
                                [major]="majorIssues().length"
                                [missing]="missingIssues().length" />
            }
            @else {
              <div class="cm-issue-total">
                {{cmIssues().length}}
              </div>
            }
          </div>
        </div>
        <div class="issues"
             data-testid="final-review-issues-list">
          @if (minorIssues() && minorIssues().length > 0) {
            <div class="severity-title"
                 data-testid="final-review-text-minor-title">Minor</div>
            <div class="issue-list-container"
                 data-testid="final-review-list-minor">
              <div *ngFor="let minorIssue of minorIssues()">
                <needs-attention-item [issueWithDetail]="minorIssue"
                                      (navToIssue)="navToIssue(minorIssue.issue.id!, minorIssue.issue.assertionIdentifier, true)" />
              </div>
            </div>
          }
          @if (majorIssues() && majorIssues().length > 0) {
            <div class="severity-title"
                 [ngStyle]="minorIssues() && minorIssues().length ? { 'padding-top': '1.5rem' } : { }"
                 data-testid="final-review-text-major-title">Major</div>
            <div class="issue-list-container"
                 data-testid="final-review-list-major">
              <div *ngFor="let majorIssue of majorIssues()">
                <needs-attention-item [issueWithDetail]="majorIssue"
                                      (navToIssue)="navToIssue(majorIssue.issue.id!, majorIssue.issue.assertionIdentifier, true)" />
              </div>
            </div>
          }
          @if (missingIssues() && missingIssues().length > 0) {
            <div class="severity-title"
                 [ngStyle]="majorIssues() && majorIssues().length ? { 'padding-top': '1.5rem' } : { }"
                 data-testid="final-review-text-missing-title">Missing</div>
            <div class="issue-list-container"
                 data-testid="final-review-list-missing">
              <div *ngFor="let missingIssue of missingIssues()">
                <needs-attention-item [issueWithDetail]="missingIssue"
                                      (navToIssue)="navToIssue(missingIssue.issue.id!, missingIssue.issue.assertionIdentifier, true)" />
              </div>
            </div>
          }
          @if (cmIssues() && cmIssues().length > 0) {
            <div class="severity-title"
                 [ngStyle]="majorIssues() && majorIssues().length ? { 'padding-top': '1.5rem' } : { }"
                 data-testid="final-review-text-cm-title">Issues</div>
            <div class="issue-list-container"
                 data-testid="final-review-list-cm">
              <div *ngFor="let cmIssue of cmIssues()">
                <needs-attention-item [issueWithDetail]="cmIssue"
                                      (navToIssue)="navToIssue(cmIssue.issue.id!, cmIssue.issue.assertionIdentifier, true)" />
              </div>
            </div>
          }
        </div>
      }
      @else {
        <div class="empty-state"
             data-testid="final-review-container-no-issues">
          <img class="icon"
               src="assets/icons/home-mode-outline-rounded.svg"
               alt="Looking great!" />
          <div class="title">No issues logged - looking great!</div>
          <div class="subtitle">{{ 'Next, review completed items\n with photos or notes.' }}</div>
        </div>
      }

    }
    @else {
      @if (hasLooksGoodItemsToReview()) {
        <div class="severity-title"
             data-testid="final-review-text-looks-good-title">Looks Good</div>
        <div class="issue-list-container"
             data-testid="final-review-list-looks-good">
          <div *ngFor="let item of looksGoodItemsWithDetails()">
            <looks-good-item [assertionWithDetail]="item"
                             (navToIssue)="navToIssue(0, item.assertion.identifier, false)" />
          </div>
        </div>
      }
      @else {
        <div class="empty-state"
             data-testid="final-review-container-no-looks-good">
          <img class="icon"
               src="assets/icons/fact-check-outline.svg"
               alt="All clear!" />
          <div class="title">Nothing to review here.</div>
          <div class="subtitle">{{'No notes or images were \n added to completed items.'}}</div>
        </div>
      }
    }
  } @else {
    <div class="final-review-skeleton"
         data-testid="final-review-skeleton">
      <p-skeleton height="200px"></p-skeleton>
      <p-skeleton height="150px"></p-skeleton>
    </div>
  }

</div>
<!-- FOOTER -->
@if (dataLoaded) {
  <app-job-detail-footer [buttonText]="nextButtonText()"
                         [completedItems]="footerBarCompletedItems()"
                         [totalItems]="footerBarTotalItems()"
                         (buttonClickCallBack)="nextClick()" />
}